    <!-- =========================================================================================
    File Name: ChangeTimeDurationDropdown.vue
    Description: Change duration dropdown component
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<!-- :class="data.class" -->

<template>
    <div>
      <small>Prefer Country: </small>
      <vs-dropdown vs-trigger-click class="cursor-pointer">
          <small class="flex cursor-pointer">
            <span>{{$store.getters.getUserCountry.name}}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" class="ml-1" />
          </small>
          <vs-dropdown-menu class="w-32">
              <vs-dropdown-item @click="onClickDropdownItem(country)" v-for="(country, index) in $store.state.country.country_list" :key="`country_list_${index}`">{{country.name}}</vs-dropdown-item>
          </vs-dropdown-menu>
      </vs-dropdown>
    </div>
</template>
<script>
  import Global from '@/helper/global'

  export default {
    name: 'change-country-dropdown',
    data(){
      return {

      }
    },
    computed: {
      hasOnChangeListener(){
        return this.$listeners && this.$listeners.change
      }
    },
    methods:{
      onClickDropdownItem(item){
        Global.initialize(this, item);

        if(this.hasOnChangeListener){
          this.$emit('change')
        }
      }
    }
  }
</script>
